import React from "react";
import UserDetailContainer from "containers/panel/admin/user-detail-container";

const UserDetailPage = () => {
  return (
    <UserDetailContainer/>
  )
}

export default UserDetailPage